const REQUIRED_MESSAGE = 'All fields are required.';

const validateNonOfficer = (wagePaid, hoursWorked, maxNonOfficerRate, extremeWage) => {
    if (wagePaid === '' || hoursWorked === '') {
        return {
            result: false,
            severity: 'FATAL',
            errorMessage: REQUIRED_MESSAGE
        };
    }

    const wagePaidNumber = Number(wagePaid.replace(/[^0-9.-]+/g, ''));
    const hoursWorkedNumber = Number(hoursWorked.replace(/[^0-9.-]+/g, ''));
    const hourlyWage = wagePaidNumber / hoursWorkedNumber;
    if (hourlyWage > extremeWage) {
        return {
            result: false,
            severity: 'FATAL',
            errorMessage: 'Hourly wage is significantly greater than expected. Extreme wages require correction or additional information.'
        }
    }

    if (hourlyWage > maxNonOfficerRate) {
        return {
            result: false,
            severity: 'WARNING',
            errorMessage: 'Hourly wage is greater than expected. Review entries and confirm officers are excluded.'
        }
    }

    return { result: true };
}

const validateOfficer = (officerName, classCode, wagePaid, hoursWorked, maxOfficerRate, minOfficerRate) => {
    if (officerName === '' || classCode === '' || wagePaid === '' || hoursWorked === '') {
        return {
            result: false,
            severity: 'FATAL',
            errorMessage: REQUIRED_MESSAGE
        };
    }

    const wagePaidNumber = Number(wagePaid.replace(/[^0-9.-]+/g, ''));
    if (wagePaidNumber > maxOfficerRate) {
        return {
            result: false,
            severity: 'FATAL',
            errorMessage: `Maximum applicable Wage Paid allowed for Officers is $${(maxOfficerRate).toLocaleString('en')}. Please correct.`
        }
    }

    if (wagePaidNumber < minOfficerRate) {
        return {
            result: false,
            severity: 'FATAL',
            errorMessage: `Minimum applicable Wage Paid allowed for Officers is $${(minOfficerRate).toLocaleString('en')}. Please correct.`
        }
    }

    return { result: true };
}

const passesFinalValidations = (nonOfficers, officers, maxRate, maxPayroll, minPayroll, extremeWage) => {
    let result = true;
    for (let i = 0; i < officers.length; i++) {
        let officerResult = validateOfficer(officers[i].officerName,
                                            officers[i].classCode,
                                            officers[i].wagePaid,
                                            officers[i].hoursWorked,
                                            maxPayroll,
                                            minPayroll);
        if (!officerResult.result && officerResult.severity === 'FATAL') {
            result = false;
            officers[i].errorMessage = officerResult.errorMessage;
        }
    }

    for (let j = 0; j < nonOfficers.length; j++) {
        let nonOfficerResult = validateNonOfficer(nonOfficers[j].wagePaid,
                                                  nonOfficers[j].hoursWorked,
                                                  maxRate,
                                                  extremeWage);
        if (!nonOfficerResult.result && nonOfficerResult.severity === 'FATAL') {
            result = false;
            nonOfficers[j].errorMessage = nonOfficerResult.errorMessage;
        }
    }

    return result;
}

export { validateNonOfficer, validateOfficer, passesFinalValidations };